import React, { useState } from "react";
import { ReactComponent as IconLive } from "../../../../../assets/images/icons/icon-live-green.svg";
import { ReactComponent as IconInProgress } from "../../../../../assets/images/icons/icon-inprogress.svg";
import { ReactComponent as IconInfo } from "../../../../../assets/images/icons/icon-info.svg";
import { ReactComponent as IconDownloadError } from "../../../../../assets/images/icons/icon-download-error.svg";
import DeleteRedIcon from '../../../../../assets/images/icons/delete-red-icon.svg'
import { Link, useNavigate } from "react-router-dom";
import TableListing from "../../../../../components/TableListing/TableListing";
import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { addcatalog, catalogsupload, viewcatalog, viewmaincatalog } from "../../../../../config/routingConsts";
import Button from "../../../../../components/Button/Button";
import ModalPopup from "../../../../../components/Modal/ModalPopup";
import { DELETE_WHOLE_CATALOG_DATA, SELLER_LISTPRODUCT } from "../../../../../Redux-Toolkit/Actions/sagaActions";
import { useDispatch } from "react-redux";


function CatalogsUploadData({ ListProductDD ,tabName }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [deleteProductIDModalShow, setDeleteProductIdModalShow] =useState(false)
  const [storeId, setStoreId] = useState(null)

  const deleteCatalogue = (cataloge_id) =>{
    setDeleteProductIdModalShow(true)
        setStoreId(cataloge_id)
  }
console.log(ListProductDD?.data?.map((tr)=>tr?.id),"ListProductDD ListProductDD");
  const onYesBtnClickCatalog = (productId) => {
    if (productId) {
        // setDeleteProductIdModalShow(false)
        dispatch({
            type: DELETE_WHOLE_CATALOG_DATA,
            payload: { catalogId: productId },
            callback: () => {
                navigate(catalogsupload)
                dispatch({type:SELLER_LISTPRODUCT})
            }
        })
    }
    setDeleteProductIdModalShow(false)
}


  const transformDataForTable = (data) => {
    return data?.map((item, index, arr) => ({
      no: index + 1,
      category: item?.mainCategoryName,
      subcategory: item?.categoryName,
      // fileId: item?.id,
      productName:item?.productName,
      createDate: item?.createdDate,
      status: item?.status===1 ? (<p className='status'><IconLive/> Live</p>) 
              :(item?.status===7) ? (<p className='status'> <IconInProgress/> In-Progress</p>)
              :(item?.status===5) ? (<p className='status'><IconInfo/> QC Error</p>)
              : null,
      action: (
        <div className="action-group">
          {item?.status===1 ? 
          // (<Link className="solid-black-btn table-btn" to={`${viewmaincatalog}/${item?.id}`}>View</Link> )
          (<Link className="solid-black-btn table-btn" to={`${viewcatalog}/${item?.id}`} state = "Catalogs Upload">View</Link>) 
              :(item?.status===7) ? ''
              :(item?.status===5) ? (<div className='action-group'>
              <p className='text-red status'><IconDownloadError/> Download Error File</p> 
              <Link className='solid-black-btn table-btn' to={`${viewcatalog}/${item?.id}`}>Upload New File</Link>
          </div>)
              : null}
            <Button
              type="button" 
              text="Delete"
              commonClass="solid-red-btn table-btn"
              onClick={()=>{deleteCatalogue(item?.id)}}
            />
          {/* <Link className="solid-black-btn table-btn" to={`${viewcatalog}/${item?.id}`} state = "Catalogs Upload">View</Link> */}
          {/* <Link className="solid-black-btn table-btn" to={viewcatalog}>View</Link> */}
        </div>
      ),
    }));
  };

  const columnHelper = createColumnHelper();

  const columns = [

    columnHelper.accessor((row) => row?.no, {
      id: "no",
      header: () => "No.",
    }),
    columnHelper.accessor((row) => row?.category, {
      id: "category",
      header: () => "Category",
    }),
    columnHelper.accessor((row) => row?.subcategory, {
      id: "subcategory",
      header: () => "Sub-Category",
    }),
    // columnHelper.accessor((row) => row?.fileId, {
    //   id: "fileId",
    //   header: () => "File ID",
    // }),
    columnHelper.accessor((row) => row?.productName, {
      id: "productName",
      header: () => "product Name",
    }),
    columnHelper.accessor((row) => row?.createDate, {
      id: "createDate",
      header: () => "Created Date",
    }),
    columnHelper.display({
      id: "status",
      header: () => "QC Status",
      cell : (row) => row?.row?.original?.status
    }),  

    columnHelper.display({
      id: "action",
      header: () => "Action",
      cell: (row) => row?.row?.original?.action,
    }),
  ];
  const transformedData = transformDataForTable(ListProductDD.data);
  const table = useReactTable({
    data: transformedData || [],
    columns: columns || [],
    // createColumnHelper : getCreateColumnHelper(),
    // onSortingChange: setSorting,
    // getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
  });
  return (
    <>
      <div className="catalogs-table">
        {/* <table className='table'>
            <thead>
                <tr>
                    <th>No</th>
                    <th>Category</th>
                    <th>Sub-Category</th>
                    <th>File ID</th>
                    <th>Created Date</th>
                    <th>QC Status</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>Women</td>
                    <td>Lehenga</td>
                    <td>18552285585588-Lehenga-10256=-External</td>
                    <td>26-07-2022   03:45 PM</td>
                    <td><p className='status'><IconLive/> Live</p></td>
                    <td><Link className='solid-black-btn table-btn'>View</Link></td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>Women</td>
                    <td>Lehenga</td>
                    <td>18552285585588-Lehenga-10256=-External</td>
                    <td>26-07-2022   03:45 PM</td>
                    <td><p className='status'><IconInProgress/> In-Progress</p></td>
                    <td><Link className='solid-black-btn table-btn'>View</Link></td>
                </tr>
                <tr>
                    <td>3</td>
                    <td>Women</td>
                    <td>Lehenga</td>
                    <td>18552285585588-Lehenga-10256=-External</td>
                    <td>26-07-2022   03:45 PM</td>
                    <td><p className='status'><IconInfo/> QC Error</p></td>
                    <td>
                        <div className='action-group'>
                            <p className='text-red status'><IconDownloadError/> Download Error File</p> 
                            <Link className='solid-black-btn table-btn'>Upload New File</Link>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table> */}
        <TableListing
          table={table}
          ListProductDD={ListProductDD.data}
        />

        {/* delete modal on catalogue */}
        <ModalPopup
                show={deleteProductIDModalShow}
                handleClose={() => setDeleteProductIdModalShow(true)}
                handleShow={() => setDeleteProductIdModalShow(true)}
                cname="accept-item confirm-modal delete-modal"
            >
                <img src={DeleteRedIcon} alt="" />
                <h2>Do you want to delete your product catalog?</h2>
                <div className="modal-btn-group">
                    <Button
                        type="button"
                        commonClass="border-red-btn modal-btn"
                        text={'No'}
                        onClick={() => setDeleteProductIdModalShow(false)}
                    />
                    <Button
                        type="button"
                        commonClass="solid-red-btn modal-btn"
                        text={'Yes'}
                        onClick={() => {
                            onYesBtnClickCatalog(storeId)
                            // dispatch(sellerDeleteProductSuccess(delID))
                        }}
                    />
                </div>
            </ModalPopup>


        {/* delete modal end */}



      </div>
    </>
  );
}

export default CatalogsUploadData;